var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3494 11.5767L18.7727 11.1534C20.4091 9.51695 20.4091 6.86376 18.7727 5.22733C17.1362 3.59089 14.483 3.59089 12.8466 5.22733L9.66786 8.40604C8.38431 9.68958 8.38431 11.7706 9.66786 13.0542L10.7301 14.1164M5.65062 12.4233L5.22733 12.8466C3.59089 14.483 3.59089 17.1362 5.22733 18.7727C6.86378 20.4091 9.51698 20.4091 11.1534 18.7727L14.3321 15.594C15.6157 14.3104 15.6157 12.2294 14.3321 10.9458L13.2699 9.88358",
    stroke: "#D5DAE0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7d185ae22c7d6b179c8eccaa82d0016b.svg";
export { ForwardRef as ReactComponent };